import { Box } from '@rbilabs/universal-components';

import { theme } from 'styles/configure-theme';
import { primitive } from 'styles/constants/primitives';

export const ProductCustomizationPanel = Box.withConfig({
  height: 'full',
  width: 'full',
  alignSelf: 'center',
});

export const ProductCustomizationFixedHeader = Box.withConfig({
  borderBottomWidth: 1,
  borderColor: theme.token('border-color-default'),
  backgroundColor: theme.token('background-pattern'),
});

export const ModifierGroupContainer = Box.withConfig({
  width: 'full',
  margin: 0,
  padding: 0,
});

export const ProductSelectedItemCustomizationContainer = Box.withConfig({
  width: 'full',
  paddingX: '$2',
  paddingY: '$4',
  backgroundColor: primitive.$blackOpacity4,
  marginY: '$4',
  borderRadius: Styles.borderRadius,
});
